import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import HeadingUppercase from '../HeadingUppercase';

function Heading(_ref) {
  var children = _ref.children,
      restProps = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return /*#__PURE__*/React.createElement(HeadingUppercase, _extends({
    paddingBottom: 0.5,
    paddingHorizontal: 2,
    paddingTop: 1
  }, restProps), children);
}

Heading.displayName = 'Menu.Heading';
export default Heading;